import React from 'react';
import { Tooltip as MUITooltip, TooltipProps as MUITooltipProps } from '@mui/material';

export type TooltipProps = {
  children: React.ReactElement;
  title: React.ReactNode;
  placement?: MUITooltipProps['placement'];
  maxWidth?: string | number;
};

const DEFAULT_TOOLTIP_MAX_WIDTH = 300;

export const Tooltip = ({
  children,
  title,
  placement = 'top-end',
  maxWidth = DEFAULT_TOOLTIP_MAX_WIDTH,
}: TooltipProps) => {
  return (
    <MUITooltip
      arrow
      title={title}
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: (theme) => ({
            // TODO fix, maybe merge with an identical solution we have in OCX FE
            // @ts-ignore in sx props theme has "typography" as unknown type
            ...theme.typography.body2,
            backgroundColor: theme.palette.common.black,
            padding: theme.spacing(1),
            maxWidth: maxWidth,
          }),
        },
        arrow: { sx: { color: 'black' } },
      }}
    >
      {children}
    </MUITooltip>
  );
};
